import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { WFEBudgetedGLAccountSelectorResultDto } from '../../shared-workflow-module/_models/wfe-budgeted-gl-account-selector-result-dto';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
const ɵ0 = () => WFEBudgetedGLAccountSelectorResultDto, ɵ1 = () => DimensionSelectorResultDto;
export class PaymentRequestCodingEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], PaymentRequestCodingEditorResultDto.prototype, "glAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], PaymentRequestCodingEditorResultDto.prototype, "dimensions", void 0);
export { ɵ0, ɵ1 };
